export const MOCK_DATA: Record<string, any>[] = [
  {
    "display_name": "TestMockLink",
    "route_name": "TestMockLink",
    "product": null,
    "id": "3e190b48-fa87-4147-b114-28e48bec8327",
    "link_guid": "9fdf496c-4e41-4ad7-ad6d-26fec8ac7eba",
    "created_date": "2026-07-30T20:05:00.281Z",
    "updated_date": "2026-07-30T20:05:00.281Z",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  }
]